export const PATHS = {
  home: '/',
  products: '/produkty',
  searchResults: '/szukaj',
  // profile
  profile: '/profil',
  profileOrders: '/profil/zamowienia',
  profileDetails: '/profil/dane',
  profileRebateCodes: '/profil/kody-rabatowe',
  profileDeliveryAddress: '/profil/adresy-dostaw',
  profileInvoiceDetails: '/profil/dane-faktury',
  profileComplaints: '/profil/reklamacje',
  profileFavourites: '/profil/ulubione',
  // profile - campaigns
  profileRewardsProgram: '/profil/program-nagrod',
  // auth
  login: '/logowanie',
  register: '/rejestracja',
  forgotPassword: '/reset-hasla',
  resetPassword: '/zmiana-hasla',
  benefits: '/korzysci',
  emailConfirmation: '/weryfikacja',
  changeEmailConfirmation: '/zmiana-adresu-email',
  supportSession: '/wsparcie', // For impersonation of a customer by a support agent.
  // store
  categories: '/kategorie',
  cart: '/koszyk',
  delivery: '/dostawa',
  payment: '/platnosc',
  orderSummary: '/podsumowanie/:id',
  brand: '/wytworcy',
  privacy: '/polityka-prywatnosci',
  termsAndConditions: '/regulamin',
  cancellation: '/odstapienie-od-umowy',
  mostFrequentlyBought: '/najczesciej-kupowane',
  bestsellers: '/specjaly',
  promoted: '/promocje', // unused
  newestProducts: '/nowosci',
  // info
  faq: '/faq',
  aboutUs: '/o-nas',
  cooperation: '/wspolpraca',
  quality: '/gwarancja-jakosci',
  deliveryArea: '/o-dostawie/obszary-dostawy',
  deliveryTime: '/o-dostawie/terminy-i-metody-dostawy',
  deliveryCost: '/o-dostawie/koszty-dostawy',
  paymentMethods: '/o-dostawie/metody-platnosci',
  howToRegister: '/jak-zalozyc-konto',
  howToMakeOrder: '/jak-zlozyc-zamowienie',

  // newsletter
  newsletterSubscribe: '/zapis-do-newslettera',
  newsletterUnsubscribe: '/wypisanie-z-newslettera',
  welcomePackage: '/pakiet-powitalny',
  newsletterResignation: '/rezygnacja',

  // documents
  documents: '/dokumenty/[slug]',

  // campaigns
  rewardsProgram: '/program-nagrod',

  // pagebuilder
  cms: '/cms/[[...index]]',
  landing: '/lp/[slug]',
  landingTest: '/lp/test/[slug]'
}

export const getPathFromDestination = (destination?: string): string => {
  switch (destination) {
    case 'cart':
      return PATHS.cart
    case 'delivery':
      return PATHS.delivery
    case 'payment':
      return PATHS.payment
    default:
      return PATHS.home
  }
}

export const getDestinationFromPathname = (pathname: string): string | null => {
  switch (true) {
    case pathname.includes(PATHS.payment):
      return 'delivery'
    case pathname.includes(PATHS.delivery):
      return 'cart'
    default:
      return null
  }
}

export enum RouteModalTriggers {
  Search = '#search'
}

export const checkAndReturnSlugToBase = (slug: string) => {
  if (slug.startsWith('/')) {
    return slug
  }

  return `/${slug}`
}
